import { loginInitialState, loginReducer } from "./LoginReducer";
import { cartInitialState, cartReducer } from "./CartReducer";
import { contactInitialState, contactReducer } from "./ContactReducer";
import { chatInitialState, chatReducer } from "./ChatReducer";
import { reviewInitialState, reviewReducer } from "./ReviewReducer";
import {
  searchDoctorInitialState,
  searchDoctorReducer,
} from "./searchReducer/searchDoctorReducer";
import {
  searchClinicInitialState,
  searchClinicReducer,
} from "./searchReducer/searchClinicReducer";
import {
  searchEventInitialState,
  searchEventReducer,
} from "./searchReducer/searchEventReducer";
import {
  searchProductInitialState,
  searchProductReducer,
} from "./searchReducer/searchProductReducer";
import {
  searchGroupInitialState,
  searchGroupReducer,
} from "./searchReducer/searchGroupReducer";
import {
  searchChallengeInitialState,
  searchChallengeReducer,
} from "./searchReducer/searchChallengeReducer";
import {
  searchArticleInitialState,
  searchArticleReducer,
} from "./searchReducer/searchArticleReducer";
import {
  searchSuccessStoryInitialState,
  searchSuccessStoryReducer,
} from "./searchReducer/searchSuccessStoryReducer";

// Combine all initial states
export const initialState = {
  login: loginInitialState,
  cart: cartInitialState,
  contact: contactInitialState,
  chat: chatInitialState,
  review: reviewInitialState,
  searchDoctor: searchDoctorInitialState,
  searchClinic: searchClinicInitialState,
  searchEvent: searchEventInitialState,
  searchProduct: searchProductInitialState,
  searchGroup: searchGroupInitialState,
  searchChallenge: searchChallengeInitialState,
  searchArticle: searchArticleInitialState,
  searchSuccessStory: searchSuccessStoryInitialState,
};
// Combine all reducers manually
export const rootReducer = (state, action) => ({
  login: loginReducer(state.login, action),
  cart: cartReducer(state.cart, action),
  contact: contactReducer(state.contact, action),
  chat: chatReducer(state.chat, action),
  review: reviewReducer(state.review, action),
  searchDoctor: searchDoctorReducer(state.searchDoctor, action),
  searchClinic: searchClinicReducer(state.searchClinic, action),
  searchEvent: searchEventReducer(state.searchEvent, action),
  searchProduct: searchProductReducer(state.searchProduct, action),
  searchGroup: searchGroupReducer(state.searchGroup, action),
  searchChallenge: searchChallengeReducer(state.searchChallenge, action),
  searchArticle: searchArticleReducer(state.searchArticle, action),
  searchSuccessStory: searchSuccessStoryReducer(
    state.searchSuccessStory,
    action
  ),
});
